
<div class="status-chip" [ngClass]="status?.toLowerCase()">
  {{status || 'Status Unknown'}}
</div>